import { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog';
import AlternativeDetailsDialog from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue";
import { CriterionDetailsDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionDetailsDialog';
import CriterionDetailsDialog from "@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue";
import PanelistConsistencyAnalysisDialog from '@Evaluation/AlternativesSurveys/Components/PanelistConsistencyAnalysisDialog.vue';
import { ExportPanelistVotesToXlsCommandV1 } from "@Evaluation/AlternativesSurveys/Domain/commands-core";
import ScoringCommands from '@Evaluation/AlternativesSurveys/Domain/commands-vue-component';
import ScoringQueries from '@Evaluation/AlternativesSurveys/Domain/queries-vue-component';
import { PanelistConsistencyAnalysisReadModel, PanelistSurveyDashboardPageReadModel, ScoringAlternativeReadModel, ScoringCriterionReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { numCompare, strCompare } from "@common/Common";
import { ICommandStatus } from '@cqrs/cqrs';
import Component, { mixins } from 'vue-class-component';

@Component({
    components: { PanelistConsistencyAnalysisDialog, AlternativeDetailsDialog, CriterionDetailsDialog }
})
export default class PanelistSurveyDashboardPage extends mixins(ScoringCommands, ScoringQueries) {

    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId); }
    get projectUserId(): number { return Number.parseInt(this.$route.params.projectUserId); }

    initialized: boolean = false;
    alternativeDetailsDialog = new AlternativeDetailsDialogViewModel();
    criterionDetailsDialog: CriterionDetailsDialogViewModel = new CriterionDetailsDialogViewModel();
    ByAlternative: boolean = true;
    OrderByProgressAsc: boolean = true;
    SearchPhrase: string = null;
    panelistConsistencyAnalysis: PanelistConsistencyAnalysisReadModel = null;
    panelistConsistencyAnalysisOpened: boolean = false;

    rm: PanelistSurveyDashboardPageReadModel = null;
    get alternativeLabel(): string { return this.rm?.AlternativeLabel; }
    get alternativesLabel(): string { return this.rm?.AlternativesLabel; }
    get surveyName(): string { return this.rm?.SurveyName; }
    get surveyDescription(): string { return this.rm?.SurveyDescription; }
    get meetingUrl(): string { return this.rm?.MeetingUrl; }
    get surveyQuestionsCount(): number { return this.rm?.SurveyQuestionsCount; }

    get viewTemplate(): string
    {
        if (this.initialized === false) { return "loading"; }
        else if (this.rm.IsClosed === true) { return "closed"; }
        else if (this.rm.SurveyQuestionsCount === 0) { return "empty"; }
        else { return "default"; }
    }

    get Alternatives() { return this.rm?.Alternatives ?? []; }
    get Criteria() { return this.rm?.Criteria ?? []; }

    get AlternativesView(): ScoringAlternativeReadModel[]
    {
        const altCompare = (a: ScoringAlternativeReadModel, b: ScoringAlternativeReadModel) =>
        {
            let progressCompare = numCompare(a.Progress, b.Progress);

            if (this.OrderByProgressAsc === true)
            {
                progressCompare *= -1;
            }

            return progressCompare === 0 ? strCompare(a.Name, b.Name) : progressCompare;
        }

        const phrase = this.SearchPhrase?.toLowerCase() ?? "";
        const view = this.Alternatives.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
        return view.sort((a, b) => altCompare(a, b));
    }

    get CriteriaView(): ScoringCriterionReadModel[]
    {
        const critCompare = (a: ScoringCriterionReadModel, b: ScoringCriterionReadModel) =>
        {
            let progressCompare = numCompare(a.Progress, b.Progress);

            if (this.OrderByProgressAsc === true)
            {
                progressCompare *= -1;
            }

            return progressCompare === 0 ? strCompare(a.Path, b.Path) : progressCompare;
        }

        const phrase = this.SearchPhrase?.toLowerCase() ?? "";
        const view = this.Criteria.filter(o => o.Path.toLowerCase().indexOf(phrase) >= 0);
        return view.sort((a, b) => critCompare(a, b));
    }

    get ViewByLabel(): string 
    {
        return this.ByAlternative === true ? this.alternativeLabel : "Criterion";
    }

    showAlternativeDetailsDialog(a: ScoringAlternativeReadModel)
    {
        this.alternativeDetailsDialog.show(a.Name, a.Description);
    }

    showCriterionDetailsDialog(c: ScoringCriterionReadModel)
    {
        this.criterionDetailsDialog.show(c.Name, c.Path, c.Description);
    }

    ToggleOrderByProgressCommand()
    {
        this.OrderByProgressAsc = !this.OrderByProgressAsc;
    }

    ToggleViewByCommand()
    {
        this.ByAlternative = !this.ByAlternative;
    }


    showRespondentConsistencyAnalysis()
    {
        this.panelistConsistencyAnalysis = null;
        this.panelistConsistencyAnalysisOpened = true;
        this.runPanelistConsistencyAnalysisQueryV1(this.workspaceId, this.rm.ProjectId, this.rm.EvalModelId, this.surveyId, this.projectUserId);
    }


    handleExportPanelistVotesToXlsCommand()
    {
        this.invokeExportPanelistVotesToXlsCommandV1(this.workspaceId, this.rm.ProjectId, this.rm.EvalModelId, this.surveyId, this.projectUserId);
    }

    mounted()
    {
        this.runPanelistSurveyDashboardPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PanelistSurveyDashboardPageReadModel")
        {
            this.rm = model as PanelistSurveyDashboardPageReadModel;
            this.initialized = true;
        }
        else if (modelName == "PanelistConsistencyAnalysisReadModel")
        {
            this.panelistConsistencyAnalysis = model as PanelistConsistencyAnalysisReadModel;
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (ExportPanelistVotesToXlsCommandV1.matchType(cmd))
        {
            location.href = result;
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        //if (UpdateCriterionCommandV1.matchType(status.Command))
        //{
        //    this.displayValidationErrors(status.ValidationErrors);
        //}
    }
}